import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { ArrowRight, Clock, Award } from "lucide-react";
import { courseImage } from "@/lib/images";

const providerColor = {
  "Amazon Web Services": "text-amber-400",
  "Microsoft Azure": "text-sky-400",
  "Google Cloud": "text-emerald-400",
  "Python Institute": "text-yellow-300",
};

export function CourseCard({ c, index = 0 }) {
  return (
    <Link to={`/courses/${c.slug}`} data-testid={`course-card-${c.slug}`}
      className="card-glow rounded-xl border border-white/10 flex flex-col group overflow-hidden"
      style={{ backgroundColor: "#131C38", animationDelay: `${index * 60}ms` }}>
      <div className="relative h-36 overflow-hidden">
        <img src={courseImage(c)} alt={c.title} className="h-full w-full object-cover opacity-90 group-hover:scale-105 transition-transform duration-500" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#131C38] via-[#131C38]/40 to-transparent" />
        <Badge variant="outline" className="absolute top-3 right-3 border-gold/40 text-gold bg-[#0B132B]/70 rounded-full text-[11px]">{c.category}</Badge>
      </div>
      <div className="p-6 flex flex-col flex-1">
        <span className={`text-xs font-mono uppercase tracking-widest ${providerColor[c.provider] || "text-slate-400"}`}>{c.provider}</span>
        <h3 className="font-display text-xl font-bold text-white leading-snug mt-2 group-hover:text-gold transition-colors">{c.credential || c.title}</h3>
        <p className="text-xs text-gold font-mono mt-1">{c.acronym}{c.scheme_code ? ` · ${c.scheme_code}` : ""}</p>
        <p className="text-sm text-slate-400 mt-2 flex-1 leading-relaxed">{c.tagline}</p>
        <p className="text-xs text-slate-500 mt-3 font-mono">{c.cert_line}</p>
        <div className="flex items-center gap-4 mt-4 text-xs text-slate-400">
          <span className="flex items-center gap-1"><Clock className="h-3.5 w-3.5" />{c.hours}h</span>
          <span className="flex items-center gap-1"><Award className="h-3.5 w-3.5 text-gold" />Certificate</span>
        </div>
        <div className="flex items-center justify-between mt-5 pt-4 border-t border-white/10">
          <div>
            <span className="text-2xl font-display font-extrabold text-white">{c.price}</span>
            <span className="text-sm text-slate-400 ml-1">{c.currency}</span>
          </div>
          <span className="flex items-center gap-1 text-sm font-semibold text-gold group-hover:gap-2 transition-all">
            Details <ArrowRight className="h-4 w-4" />
          </span>
        </div>
      </div>
    </Link>
  );
}
